import ProvidentFundNewsView from '../components/ProvidentFundNewsView';
export default function ProvidentFundNews(){return <ProvidentFundNewsView mode="daily"/>;}
